import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PrivacyPolicyModal from './PrivacyPolicyModal';
import { openAboutModal } from './TopNav';
import './Footer.css';

/**
 * Footer Component
 * 
 * Updated with Minimal with Dual Accent design
 */
const Footer = () => {
  // State to control the visibility of the Privacy Policy modal
  const [isPrivacyPolicyModalOpen, setIsPrivacyPolicyModalOpen] = useState(false);

  // Handler for the Privacy Policy link click
  const handlePrivacyPolicyClick = (e) => {
    e.preventDefault();
    setIsPrivacyPolicyModalOpen(true);
  };

  // Handler for the About link click
  const handleAboutClick = (e) => {
    e.preventDefault();
    openAboutModal();
  };

  // Get current year for copyright
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="welcome-footer">Create things!</div>
      <footer className="footer intro footer-modern">
        <div className="footer-content">
          <div className="footer-copyright-container">
            <span className="tk-name-footer footer-copyright-text">© {currentYear} marc.tools</span>
          </div>
          <ul className="footer-links-list">
            <li><a href="http://marc.ly" className="footer-link">PORTFOLIO</a></li>
            <li><Link to="/" className="footer-link">R&D TOOLKIT</Link></li>
            <li><a href="#about" onClick={handleAboutClick} className="footer-link">ABOUT</a></li>
            <li><a href="#privacy" onClick={handlePrivacyPolicyClick} className="footer-link">PRIVACY POLICY</a></li>
          </ul>
        </div>
      </footer>

      {/* Include the PrivacyPolicyModal component */}
      <PrivacyPolicyModal 
        isOpen={isPrivacyPolicyModalOpen} 
        onClose={() => setIsPrivacyPolicyModalOpen(false)}
      />
    </>
  );
};

export default Footer; 